// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalTemplate_header__1aNnY","title":"ModalTemplate_title__2VQL6","closeButton":"ModalTemplate_closeButton__x48o6"};